module.exports = __webpack_public_path__ + "static/header-bannerbg-ironcapx-6573a6a46f2e1512499a2d350983d5b8.png";